import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const ChevronRight = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M16.29 11.9971L7.29004 2.99715L7.99715 2.29004L16.9971 11.29L17.7043 11.9971L16.9971 12.7043L7.99715 21.7043L7.29004 20.9971L16.29 11.9971Z"
  />,
  'ChevronRight'
)

export default ChevronRight
